export const initExpandingListElement = () => {
    const expandingListItems = document.querySelectorAll('.expanding-list-item');
    expandingListItems.forEach(item => {
        const readMoreElements = item.querySelectorAll('.expanding-list-item__read-more');

        readMoreElements.forEach(readMoreElement => {
            readMoreElement.addEventListener('click', (event) => {
                console.log('clicked');

                item.classList.toggle('expanded');

                // Change the text between "Read more" and "Read less"
                const isExpanded = item.classList.contains('expanded');
                const readMoreText = readMoreElement.getAttribute('data-read-more');
                const readLessText = readMoreElement.getAttribute('data-read-less');

                const textElement = readMoreElement.querySelector('.read-more-text');
                if (textElement) {
                    textElement.textContent = isExpanded ? readLessText : readMoreText;
                }

                // Ensure both read-more buttons show the correct text
                readMoreElements.forEach(elem => {
                    const textElem = elem.querySelector('.read-more-text');
                    if (textElem) {
                        textElem.textContent = isExpanded ? readLessText : readMoreText;
                    }
                });
            });
        });
    });
};
